//@flow

// Vendors
import React from 'react';
import {useDispatch} from 'react-redux';

// Components
import {Modal} from '../../../../../modals';
import Trans from '../../../../../Trans/Trans';

// Actions
import {closeModal} from '../../../../../../../reducers/modal/modalActions';

// Styles
import '../dps-learn-more-modal.scss';
import {TxButton, TxButtonMode} from "texkit-ui";


const DpsProofOfIdModal = () => {
  const dispatch = useDispatch();
  // Switch to adjusted SCSS if on iOS device
  const userAgent = window.navigator.userAgent.toLowerCase();
  const ios = /iphone|ipod|ipad/.test( userAgent );
  return (
    <Modal
      name="DpsProofOfIdModal"
      className={
        ios ? "learn-more modal ios" : "learn-more modal"
      }
    >
      <div>
        <h2 className="h2 modal-header">
          <Trans file="dps" id="dps_ProofOfId_Modal_Title"/>
        </h2>
        <p className="modal-description">
          <Trans file="dps" id="dps_ProofOfId_Modal_Desc1"/>
          <Trans className="proof-of-id-desc" file="dps" id="dps_ProofOfId_Modal_Desc2"/>
        </p>
      </div>

      <TxButton className="modal-close-button"
                mode={TxButtonMode.Primary}
                type="submit"
                onClick={() => dispatch(closeModal("DpsProofOfIdModal"))}
      >
        <Trans file="Labels" id="gotIt" fallback="OK, got it"/>
      </TxButton>
    </Modal>
  );
};

export default DpsProofOfIdModal;
